/** Figma Teacher Manual tokens (file rkYe1nR5eHpWPW6SUkUQso). Colors are hex without #. */

export const TEACHER_MANUAL_ACCENT = "F19500";

export const teacherManualDark = {
  background: "1A1A1A",
  card: "242424",
  cardBorder: "1A1A1A",
  cardBorderAlpha: 90,
  text: "FFFFFF",
  muted: "9CA3AF",
  accent: TEACHER_MANUAL_ACCENT,
  accentSoft: "1F1808",
  accentSoftBorder: "3D2E08",
  footerMuted: "9CA3AF",
  deco: "F19500",
  highlightFill: "1F1808",
  pillMutedFill: "242424",
  pillMutedText: "FFFFFF",
  placeholderFill: "2A2A2A",
  takeawayFill: "242424",
  calloutFill: "242424",
  divider: "3F3F46",
};

export const teacherManualLight = {
  background: "FFFFFF",
  card: "FAFAFA",
  cardBorder: "E5E7EB",
  text: "1A1A1A",
  muted: "4B5563",
  accent: TEACHER_MANUAL_ACCENT,
  accentSoft: "FFF8EC",
  accentSoftBorder: "F8D7A4",
  footerMuted: "9CA3AF",
  deco: "F8D7A4",
  highlightFill: "FFF8EC",
  pillMutedFill: "E5E7EB",
  pillMutedText: "4B5563",
  placeholderFill: "F3F4F6",
  takeawayFill: "FFF8EC",
  calloutFill: "FAFAFA",
  divider: "E5E7EB",
};

export const teacherManualTheme = {
  primary: TEACHER_MANUAL_ACCENT,
  text: "1A1A1A",
  muted: "4B5563",
  light: "FAFAFA",
  white: "FFFFFF",
  titleBar: TEACHER_MANUAL_ACCENT,
};

export function resolveTeacherManualPalette(variant = "light") {
  return variant === "dark" ? teacherManualDark : teacherManualLight;
}
